exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.company-list\n{\n  padding-top: 30px;\n}\n.company-item\n{\n  height: 120px;\n  margin: 5px 3px 3px 3px;\n}\n.company-content\n{\n  text-align: center;\n  color: #0b6d77;\n}\n.select-city-comment\n{\n  text-align: right;\n}\n\n@media (max-width: 767px) {\n\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/app/component/company-list/company-list.component.css
// module id = 1042
// module chunks = 3